/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { RunType } from 'models/viewModels';

export enum RaceProgressionItemType {
  Event = 'event',
  SessionType = 'sessionType',
  TimeCompletion = 'timeCompletion',
  StageNum = 'stageNum',
  RaceLaps = 'raceLaps',
  RaceLeft = 'raceLeft',
  StageLaps = 'stageLaps',
  StageLeft = 'stageLeft',
  GreenLaps = 'greenLaps',
  YellowLaps = 'yellowLaps',
  Flag = 'flag',
}

export const getRaceProgressionItemLabel = (item: RaceProgressionItemType, sessionType?: RunType): string => {
  switch (item) {
    case RaceProgressionItemType.Event:
      return 'Event';
    case RaceProgressionItemType.SessionType:
      return 'Session';
    case RaceProgressionItemType.TimeCompletion:
      return sessionType === RunType.RACE ? 'Race Time' : 'Session Time';
    case RaceProgressionItemType.StageNum:
      return 'Stage Num';
    case RaceProgressionItemType.RaceLaps:
      return 'Race Laps';
    case RaceProgressionItemType.RaceLeft:
      return 'Race Left';
    case RaceProgressionItemType.StageLaps:
      return 'Stage Laps';
    case RaceProgressionItemType.StageLeft:
      return 'Stage Left';
    case RaceProgressionItemType.GreenLaps:
      return 'Green Laps';
    case RaceProgressionItemType.YellowLaps:
      return 'Yellow Laps';
    case RaceProgressionItemType.Flag:
      return 'Flag';
    default:
      return '';
  }
};
